import { ButtonRoundedColor } from "@/stories/Button.stories";
import Button from "./Cards/Button";

interface MasterclassStatsProps {
    videos_duration?: string;
    module_count?: string;
    videos_count?: string;
    buttonColor?: string;
    buttonTextColor?: string;
}

export default function MasterclassStats({
    videos_duration,
    module_count,
    videos_count,
    buttonColor,
    buttonTextColor,
}: MasterclassStatsProps) {
    return (
        <>
            <div className="py-4 space-y-4 lg:space-y-0 lg:space-x-5 lg:flex ">
                <div>
                    <div className=" w-full h-16 flex-col justify-start items-start inline-flex">
                        <div className="w-full text-black text-3xl font-bold  leading-10">
                            Masterclass
                        </div>
                        <div className="rounded lg:justify-center items-start gap-2 inline-flex">
                            <div className="text-black text-base font-bold  leading-normal">
                                {videos_duration}
                            </div>
                            <div className="text-black text-base font-bold  leading-normal">
                                •
                            </div>
                            <div className="text-black text-base font-bold  leading-normal">
                                {module_count} Module
                            </div>
                            <div className="text-black text-base font-bold  leading-normal">
                                •
                            </div>
                            <div className="text-black text-base font-bold  leading-normal">
                                {videos_count} Videos
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <Button
                        backgroundColor={buttonColor}
                        border={ButtonRoundedColor.args?.border}
                        hasIcon={ButtonRoundedColor.args?.hasIcon}
                        iconPlacement={ButtonRoundedColor.args?.iconPlacement}
                        iconSrc={ButtonRoundedColor.args?.iconSrc}
                        paddings={ButtonRoundedColor.args?.paddings}
                        rounded={ButtonRoundedColor.args?.rounded}
                        size={ButtonRoundedColor.args?.size}
                        text={ButtonRoundedColor.args?.text}
                        textColor={buttonTextColor}
                        textSize={ButtonRoundedColor.args?.textSize}
                    />
                </div>
            </div>
        </>
    );
}
